import type { StaffUser } from './types';

/**
 * Permission checks, never role checks: roles are editable data and a role name
 * in a branch is a bug waiting for the first custom role (CLAUDE.md §3.3).
 *
 * This is a convenience for the UI only. The server checks the same permission
 * in its Application layer — the panel hiding a button is not a control.
 */
export function hasPermission(
  user: StaffUser | null | undefined,
  permission: string,
): user is StaffUser {
  return user?.permissions.includes(permission) ?? false;
}
